import Typography from '@mui/material/Typography';
import { FormattedMessage } from 'react-intl';
import { DoseMatrix } from '~/domain/patient/doseMatrix';
import { buildDoseDisplayView } from '~/hooks/dose/doseDisplayView';
import { useDoseDisplaySettings } from '~/hooks/dose/useDoseDisplaySettings';
import { useDoseDetailView } from '~/hooks/domain/useDoseDetailView';

/**
 * The maximum of a dose as shown: scaled for display, in Gy, one decimal.
 * It only reads the dose's display settings, so listing a dose changes
 * nothing that the viewer draws.
 */
export default function DoseMaxValue({ dose }: { dose: DoseMatrix }) {
    const detail = useDoseDetailView(dose.id);
    const { settings } = useDoseDisplaySettings(dose.id);
    if (!detail) {
        return null;
    }
    const view = buildDoseDisplayView(detail, settings);
    return (
        <FormattedMessage
            id="dose.maxGy"
            values={{
                value: (
                    <Typography
                        component="span"
                        variant="monoMeta"
                        color="text.primary"
                    >
                        {view.displayMaxDoseGy.toFixed(1)}
                    </Typography>
                ),
            }}
        />
    );
}
